<template>
  <div class="maplibre-gl-container" :class="[theme]">
    <svg
      id="svgfilters"
      aria-hidden="true"
      style="position: absolute; width: 0; height: 0; overflow: hidden"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <filter
          id="custom-filter"
          x="-10%"
          y="-10%"
          width="120%"
          height="120%"
          filterUnits="objectBoundingBox"
          primitiveUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0
	                            1 0 0 0 0
	                            1 0 0 0 0
	                            0 0 0 1 0"
            in="SourceGraphic"
            result="colormatrix"
          />
          <feComponentTransfer in="colormatrix" result="componentTransfer">
            <feFuncR type="table" tableValues="0 0 0" />
            <feFuncG type="table" tableValues="0.8 0.5 0" />
            <feFuncB type="table" tableValues="0.8 0.5 0.2" />
            <feFuncA type="table" tableValues="0 1" />
          </feComponentTransfer>
          <feBlend mode="normal" in="componentTransfer" in2="SourceGraphic" result="blend" />
        </filter>
      </defs>

      <defs>
        <filter
          id="custom-filter2"
          x="-10%"
          y="-10%"
          width="120%"
          height="120%"
          filterUnits="objectBoundingBox"
          primitiveUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0
            1 0 0 0 0
            1 0 0 0 0
            0 0 0 1 0"
            in="SourceGraphic"
            result="colormatrix"
          />
          <feComponentTransfer in="colormatrix" result="componentTransfer">
            <feFuncR type="table" tableValues="0.29 0.17 0" />
            <feFuncG type="table" tableValues="0.04 0.38 0" />
            <feFuncB type="table" tableValues="0.32 0.63 0" />
            <feFuncA type="table" tableValues="0 1" />
          </feComponentTransfer>
          <feBlend mode="normal" in="componentTransfer" in2="SourceGraphic" result="blend" />
        </filter>
      </defs>
    </svg>

    <div class="map" ref="map"></div>
  </div>
</template>

<script>
import { loadMapLibreGL } from '@/utils/map';
import 'maplibre-gl/dist/maplibre-gl.css';
import { MapApp } from './utils/Map';

export default {
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loaded: false
    };
  },
  methods: {},
  async mounted() {
    await loadMapLibreGL();

    this.$mapApp = new MapApp({ container: this.$refs.map });
    this.$mapApp.init().addTianDiTuLayers({});

    this.loaded = true;
    this.$emit('loaded', this.$mapApp);
  }
};
</script>

<style lang="scss">
.maplibre-gl-container {
  width: 100%;
  height: 100%;

  .map {
    width: 100%;
    height: 100%;
  }

  &.dark .maplibregl-canvas {
    filter: url('#custom-filter');
  }

  &.dark2 .maplibregl-canvas {
    filter: url('#custom-filter2');
  }
}
</style>
